<template>
  <div class="cb-floatingBtn pr-5" id="cb-floatingBtn">
    <vs-button class="py-2" color="secondary">Help</vs-button>
  </div>
</template>

<script>
// import "/public/chatbot/chatbot.js";
import "/public/chatbot/chatbot.css";

export default {
  name: "chatbot-btn",
  data() {
    return {
      styleOptions: {
        hideUploadButton: true,
        suggestedActionLayout: 'stacked',
        suggestedActionsStackedLayoutButtonTextWrap: true,
      },
      chatBotTopBarTitle: "Help Desk",
      cbVarContainer: null,
      cbVarWebChat: null,
      cbChatInitialized: false,
      directlineUrl: null,
      theURL: "https://f0915988e1fcee2583b16f73c29400.a3.environment.api.powerplatform.com/powervirtualagents/botsbyschema/cra66_assistenteExcel/directline/token?api-version=2022-03-01-preview",
    };
  },
  mounted() {
    let chatBotLib = document.createElement("script");
    chatBotLib.setAttribute("src", "https://cdn.botframework.com/botframework-webchat/latest/webchat.js");
    document.head.appendChild(chatBotLib);

    this.init();
  },
  methods: {
    init() {
      this.buttonListener();

      const environmentEndPoint = this.theURL.slice(0, this.theURL.indexOf("/powervirtualagents"));
      const apiVersion = this.theURL
        .slice(this.theURL.indexOf("api-version"))
        .split("=")[1];

      const regionalChannelSettingsURL = `${environmentEndPoint}/powervirtualagents/regionalchannelsettings?api-version=${apiVersion}`;

      fetch(regionalChannelSettingsURL)
        .then((response) => response.json())
        .then((data) => {
          this.directlineUrl = data.channelUrlsById.directline;
        })
        .catch((err) => console.error("An error occurred: " + err));
    },
    buttonListener() {
      var cbcontainer = document.createElement('div');
      cbcontainer.classList.add('cb-container');
      cbcontainer.setAttribute('id', 'cb-container');

      var cbcontainertopbar = document.createElement('div');
      cbcontainertopbar.innerHTML = this.chatBotTopBarTitle;
      cbcontainertopbar.classList.add('cb-top-bar');
      cbcontainertopbar.setAttribute('id', 'cb-top-bar');
      cbcontainer.appendChild(cbcontainertopbar);

      var cbclosebtn = document.createElement('span');
      cbclosebtn.classList.add('cb-close-button');
      cbclosebtn.setAttribute('id', 'cb-close-button');
      cbclosebtn.innerHTML = '<svg alt="Close Button" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-x"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M18 6l-12 12"></path><path d="M6 6l12 12"></path></svg>';
      cbcontainertopbar.appendChild(cbclosebtn);

      var cbwebchat = document.createElement('div');
      cbwebchat.classList.add('cb-webchat');
      cbwebchat.setAttribute('id', 'cb-webchat');
      cbcontainer.appendChild(cbwebchat);

      document.body.appendChild(cbcontainer);

      this.cbVarContainer = cbcontainer;
      this.cbVarWebChat = cbwebchat;

      cbclosebtn.addEventListener('click', () => {
        this.cbVarContainer.style.display = 'none';
      });

      // Chatbot Open Button by Class
      const cbOpenButtons = document.querySelectorAll('.cb-openChatbot');
      cbOpenButtons.forEach(button => {
        button.addEventListener('click', () => {
          this.loadChatBotFunc();
        });
      });

      // Chatbot Open Button by ID
      const cbVarButton = document.getElementById('cb-floatingBtn');
      if (cbVarButton) {
        cbVarButton.addEventListener('click', () => {
          this.loadChatBotFunc();
        });
      }
    },
    async loadChatBotFunc() {
      if (!this.directlineUrl) {
        console.error('Direct Line URL not available yet.');
        return;
      }
      
      // Show the container
      this.cbVarContainer.style.display = 'block';

      // Prevent re-initialization on subsequent opens
      if (this.cbChatInitialized) {
        return;
      }
      this.cbChatInitialized = true;

      const user = this.$store.getters['auth/user'];
      const userDetails = {
        Name: user.name,
        Surname: user.surname || '',
        Title: user.title || '',
        Entity: user.company.CompanyName,
        Email: user.email,
        Phone: user.phone || '',
        PlatformName: 'ipr',
        PlatformUrl: window.location.origin + '/'
      };
      console.log(userDetails)
      
      fetch(this.theURL).then(response => response.json()).then(conversationInfo => {
        const directLine = window.WebChat.createDirectLine({
          domain: `${this.directlineUrl}v3/directline`,
          token: conversationInfo.token,
        });
        // Send a special "on conversation start" activity
        directLine.postActivity({
          type: 'event',
          name: 'startConversation',
          value: {
            userjson: JSON.stringify(userDetails),
          },
        }).subscribe({
          next: id => console.log(`Posted activity, assigned ID ${id}`),
          error: err => console.log(`Error posting activity ${err}`),
        });
        window.WebChat.renderWebChat(
            {
              directLine,
              styleOptions: this.styleOptions,
            },
            this.cbVarWebChat
        );
      }).catch(err => console.error('An error occurred: ' + err));
    },
  },
};
</script>

<style scoped>
#cb-floatingBtn {
    cursor: pointer;
    color: #fff;
    font-size: 15px;
}
</style>
